import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Lottie from 'lottie-react';
import _ from 'lodash';
import { Button, ModalBody, ModalFooter } from 'reactstrap';

import {
  setUserSetting,
  updateUserSettings,
} from '../../../actions/Auth';

import {
  getCurrentUser,
  userIsAdmin,
  userIsManager,
} from '../../../helpers/Auth';

import ErrorBoundary from '../../ErrorBoundary';

import checklist1 from '../../../../../../public/images/lottie/onboarding/checklist-1.json';
import checklist2 from '../../../../../../public/images/lottie/onboarding/checklist-2.json';
import checklist3 from '../../../../../../public/images/lottie/onboarding/checklist-3.json';

const OnboardingFinishedModal = ({ handleClose, handleUserSetting }) => {
  const intl = useIntl();

  const [file, setFile] = useState(null);

  const handleConfirm = () => {
    handleUserSetting({ onboarding_finished: true });
    handleClose();
  };

  useEffect(() => {
    const files = [checklist1, checklist2, checklist3];
    setFile(files[_.random(0, files.length - 1)]);
  }, []);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ModalBody>
        <div className="lottie-wrapper">
          {file && (
            <Lottie
              animationData={file}
              loop={false}
              autoplay={true}
            />
          )}
        </div>
        <p>
          {intl.formatMessage({ defaultMessage: 'If you haven\'t already, take a minute to visit your <link>workspace settings</link>. There\'s a lot you can customize to make Stockpress work for you!' }, {
            link: (msg) => (
              <Link to="/admin/workspace" onClick={handleConfirm}>
                {msg}
              </Link>
            ),
          })}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          <Button
            color="link"
            onClick={handleConfirm}
            className="mr-2"
          >
            {intl.formatMessage({ defaultMessage: 'Maybe later' })}
          </Button>
          <Button
            color="primary"
            tag={Link}
            to="/admin/workspace"
            onClick={handleConfirm}
          >
            {intl.formatMessage({ defaultMessage: 'Visit your settings' })}
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

const mapDispatchToProps = (dispatch) => ({
  handleUserSetting: (setting) => {
    const profile = getCurrentUser();
    if (profile) {
      dispatch(setUserSetting(setting));
      dispatch(updateUserSettings(profile.uuid, setting));
    }
  },
});

OnboardingFinishedModal.propTypes = {
  handleUserSetting: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(OnboardingFinishedModal);
